// extracted by mini-css-extract-plugin
export var formIframe = "ContactForm-module--form-iframe--af8da";
export var formWrapper = "ContactForm-module--form-wrapper--cc536";
export var lightVariant = "ContactForm-module--light-variant--63e25";
export var pipedriveWebForm = "ContactForm-module--pipedrive-web-form--df991";
export var skeleton = "ContactForm-module--skeleton--f51b2";